export const model = {
    id:  null,
    
    file:  "",

};
